import { Phone, Siren } from "lucide-react";
import { BRAND, waLink, telLink, monitoringTelLink } from "@/lib/brand";

export default function FloatingCTAs() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3 items-end">
      <a
        href={monitoringTelLink}
        data-testid="float-sos-btn"
        aria-label={`SOS · Monitoring room ${BRAND.monitoringPhoneDisplay}`}
        className="group relative flex items-center gap-2 rounded-full bg-red-600 text-white pl-3 pr-4 py-2.5 shadow-[0_10px_40px_rgba(220,38,38,0.5)] hover:-translate-y-0.5 transition-transform border border-red-400/40"
      >
        <span className="absolute inset-0 rounded-full bg-red-600 opacity-70 blur-md -z-10 animate-pulse" />
        <Siren className="h-5 w-5 shrink-0" />
        <div className="flex flex-col leading-tight text-left">
          <span className="font-extrabold text-sm tracking-wider">SOS</span>
          <span className="text-[10px] font-mono opacity-90 whitespace-nowrap">10 PM – 6 AM</span>
        </div>
      </a>

      <a
        href={waLink()}
        target="_blank"
        rel="noreferrer noopener"
        data-testid="float-whatsapp-btn"
        aria-label="Chat on WhatsApp"
        className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_rgba(37,211,102,0.4)] hover:-translate-y-0.5 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 blur-md -z-10" />
        <svg viewBox="0 0 32 32" className="h-6 w-6 fill-white" aria-hidden="true">
          <path d="M19.11 17.44c-.28-.14-1.63-.8-1.88-.89-.25-.09-.44-.14-.62.14-.18.28-.71.89-.87 1.07-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.22-1.37-.82-.73-1.37-1.63-1.53-1.91-.16-.28-.02-.43.12-.57.13-.13.28-.32.41-.48.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.49-.85-2.04-.22-.53-.45-.46-.62-.47l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.29 0 1.35.99 2.66 1.13 2.85.14.18 1.95 2.98 4.72 4.17.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.63-.67 1.86-1.31.23-.64.23-1.19.16-1.31-.07-.12-.25-.19-.53-.33zM16.02 4C9.39 4 4 9.39 4 16c0 2.11.56 4.15 1.62 5.94L4 28l6.24-1.62A11.94 11.94 0 0 0 16.02 28C22.65 28 28 22.63 28 16.02 28 9.4 22.65 4 16.02 4zm0 21.86c-1.79 0-3.55-.48-5.08-1.4l-.36-.21-3.7.97.99-3.6-.24-.37A9.86 9.86 0 0 1 6.14 16c0-5.44 4.44-9.87 9.88-9.87 2.64 0 5.11 1.03 6.97 2.9a9.79 9.79 0 0 1 2.89 6.99c0 5.44-4.43 9.85-9.87 9.85z"/>
        </svg>
      </a>

      <a
        href={telLink}
        data-testid="float-call-btn"
        aria-label={`Call ${BRAND.phoneDisplay}`}
        className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-brand-cyan text-black shadow-[0_10px_40px_rgba(0,229,255,0.4)] hover:-translate-y-0.5 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-brand-cyan opacity-60 blur-md -z-10" />
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
}
